import { render, staticRenderFns } from "./payment-add-or-update.vue?vue&type=template&id=44aa0b2c&scoped=true&"
import script from "./payment-add-or-update.vue?vue&type=script&lang=js&"
export * from "./payment-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./payment-add-or-update.vue?vue&type=style&index=0&id=44aa0b2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44aa0b2c",
  null
  
)

export default component.exports